import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container pt-5" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "title is-1 has-text-weight-bold has-text-centered" }
const _hoisted_4 = { class: "project-detail" }
const _hoisted_5 = { class: "project-info mb-3" }
const _hoisted_6 = { class: "subtitle is-2 has-text-weight-medium" }
const _hoisted_7 = { class: "subtitle is-4" }
const _hoisted_8 = { class: "subtitle is-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Tech Stack:", -1)
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "project-media mb-5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle is-2 has-text-weight-medium" }, "Evidence:", -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle is-2 has-text-weight-medium mb-5" }, " More details.. ", -1)
const _hoisted_15 = { class: "columns is-multiline" }
const _hoisted_16 = {
  class: "column",
  "data-aos": "fade-right"
}
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "card-content" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "title is-4 has-text-weight-bold" }, "Responsibilities", -1)
const _hoisted_20 = {
  class: "column",
  "data-aos": "fade-left"
}
const _hoisted_21 = { class: "card" }
const _hoisted_22 = { class: "card-content" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "title is-4 has-text-weight-bold" }, "Topics", -1)

import { useStore } from "../store/projects";
import { useRouter } from "vue-router";

import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectDetailView',
  setup(__props) {

const store = useStore();
const router = useRouter();

const projectId = router.currentRoute.value.params.id;

const project = store.projects.find((p) => p.id === projectId);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, " About \"" + _toDisplayString(_unref(project)?.title) + "\" ", 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(project)?.title), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(project)?.description), 1),
          _createElementVNode("p", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_unref(project)?.techStack), 1)
          ]),
          _createElementVNode("a", {
            href: _unref(project)?.site,
            class: "button is-hoverable is-small mr-3"
          }, "Get a see..", 8, _hoisted_10),
          _createVNode(_component_router_link, {
            to: "/",
            class: "button is-hoverable is-small"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Go Home")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_unref(Carousel), { "items-to-show": 1 }, {
            addons: _withCtx(() => [
              _createVNode(_unref(Navigation)),
              _createVNode(_unref(Pagination))
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(project)?.media, (media, index) => {
                return (_openBlock(), _createBlock(_unref(Slide), { key: index }, {
                  default: _withCtx(() => [
                    (media.type === 'image')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: require(`@/assets/${media.url}`),
                          alt: "Project Image"
                        }, null, 8, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(project)?.responsibilities, (responsibility) => {
                    return (_openBlock(), _createElementBlock("li", { key: responsibility }, _toDisplayString(responsibility), 1))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(project)?.topics, (topic) => {
                    return (_openBlock(), _createElementBlock("li", { key: topic }, _toDisplayString(topic), 1))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})